import * as api from '@/api';

export default {
    data() {
        return {
            driver: {
                email: null,
                username: null,
                password: null,
                firstName: null,
                lastName: null,
                phone: null,
                address: null,
                city: null,
                state: null,
                zip: null,
                sendSetupEmail: false,
                driverInfo: {
                    type: 'employee',
                    employeeCode: null,
                    driverLicense: null,
                    rate: null,
                    hiredAt: null,
                    medicalExpireAt: null,
                    tags: {},
                    // null means inherit the company default. Seeded here because
                    // syncProps resolves off $attrs, so a key missing from this
                    // record is non-reactive and would be dropped on create.
                    dispatchNotificationChannels: null,
                    primaryTruck: null,
                    primaryTrailer: null,
                },
            },

            submitPending: false,
            submitError: null,
        };
    },

    methods: {
        async createDriver() {
            if (!this.$refs.driverForm.validate()) {
                return;
            }

            const driver = { ...this.driver };
            driver.email = driver.email?.trim() || null;
            driver.username = driver.username?.trim() || null;
            driver.company = this.$store.state.company.id;

            if (driver.sendSetupEmail) {
                driver.password = null;
            }

            this.submitPending = true;
            this.submitError = null;

            const res = await api.createDriver(driver);

            this.submitPending = false;

            if (res.error) {
                // TODO: send better errors to the client from the back-end (requires refactoring)
                if (res.error.message.startsWith('duplicate key value violates unique constraint')) {
                    this.submitError = 'Email/Username is already taken';
                } else {
                    this.submitError = res.error.message;
                }

                this.$awn.alert('Failed to create driver');
                return null;
            }

            this.submitError = null;
            this.$awn.success('New driver added');

            await this.$store.dispatch('company/fetchOverview');

            return res.body;
        },
    },
};
